import { useDispatch } from "react-redux";
import { useDebouncedCallback } from "use-debounce/lib";

export default function useDebouncedDispatch(delay) {
  const dispatch = useDispatch();
  const [debouncedDispatch] = useDebouncedCallback((action) => dispatch(action), delay);
  return debouncedDispatch;
}
